// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.sort-by-filter__select .sk-select {\n  max-width: 150px;\n  height: auto;\n  padding-right: 15px;\n  border: 0;\n  font-size: 12px;\n}\n.bold-table-cell {\n  font-weight: bold;\n}\n.break-all-words {\n  word-break: break-all;\n}\n", ""]);
// Exports
module.exports = exports;
